export default "__VITE_ASSET__26344985__"